// @ts-nocheck

import { request } from '../context';
import type { ApiOptions } from '../context';
import type {
    PostInspectionDataPointNotesBody,
    BaseResponseInspectionDataPointNoteFoundResponse,
} from '../types';

/**
 * 质检结果批注保存
 *
 * @export
 * @tags 质检结果批注
 * @link [POST] /inspectionDataPointNotes
 */
export function postInspectionDataPointNotes(
    data: PostInspectionDataPointNotesBody
): Promise<BaseResponseInspectionDataPointNoteFoundResponse>;
export function postInspectionDataPointNotes(
    data: PostInspectionDataPointNotesBody,
    options: ApiOptions<never, never>
): Promise<BaseResponseInspectionDataPointNoteFoundResponse>;
export function postInspectionDataPointNotes(
    data: PostInspectionDataPointNotesBody,
    options?: ApiOptions<never, never>
): Promise<BaseResponseInspectionDataPointNoteFoundResponse> {
    return request<PostInspectionDataPointNotesBody, never, never>('/inspectionDataPointNotes', {
        ...options,
        data,
        method: 'post',
        __$requestCalleeName: 'postInspectionDataPointNotes',
    });
}

export const meta = [{ tags: ['质检结果批注'], path: '/inspectionDataPointNotes', method: 'post' }];
